var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDataProvider, useResourceContext, useNotify, useRefresh, useTranslate, } from "react-admin";
import { useMediaQuery, Divider, Typography, Grid, Button, } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { general } from "../utils/componentWizard";
import SelectedRowLeftColumn from "./SelectedRowLeftColumn";
import EditDialog from "./EditDialog";
import { dummyData } from "./helper/dummyData";
import TableDatagrid from "./TableDatagrid";
import FilterList from "./FilterList";
import { ACLData, acl } from "../utils/dummyData";
import { GenderMuiChoices } from "../subjectPage/Params";
import { StatusMuiChoices } from "../examsPage/Params";
import { OrganizationMuiChoices, UserGroupMuiChoices } from "./helper/Params";
import { TranslateUsersOrgClassHelper } from "../utils/TranslateClassHelper";
import { BODY_GRID_PADDING, NORMAL_GRID_SPACE, } from "../styles/styleConstants.data";
var UserList = function (props) {
    var _a, _b, _c;
    var location = useLocation();
    var navigate = useNavigate();
    var resource = useResourceContext(props);
    var attributeResource = "".concat(useResourceContext(props), "/userList");
    var dataProvider = useDataProvider();
    var notify = useNotify();
    var refresh = useRefresh();
    var translate = useTranslate();
    var _d = useState(dummyData), data = _d[0], setData = _d[1]; //data table data
    // const resource = "UserList";
    var _e = useState(true), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(acl), acessControlList = _f[0], setAcessControlList = _f[1];
    var _g = useState({
        id: null,
        organizations: null,
        username: null,
        lastname: null,
        firstname: null,
        email: null,
        gender: null,
        status: null,
        createdAt: null,
        updatedAt: null,
        // analyzeFromDate: splitDateTimeHelper(getTodaysDateChinaTimeZone()),
        // analyzeToDate: splitDateTimeHelper(getTodaysDateChinaTimeZone()),
        // examFromDate: splitDateTimeHelper(getTodaysDateChinaTimeZone()),
        // examToDate: splitDateTimeHelper(getTodaysDateChinaTimeZone()),
    }), filters = _g[0], setFilters = _g[1];
    useEffect(function () {
        setFilters({
            id: null,
            organizations: null,
            username: null,
            lastname: null,
            firstname: null,
            email: null,
            gender: null,
            status: null,
            createdAt: null,
            updatedAt: null,
        });
    }, []);
    var _h = useState({
        gender: GenderMuiChoices,
        organizations: OrganizationMuiChoices,
        userGroups: UserGroupMuiChoices,
        status: StatusMuiChoices,
    }), params = _h[0], setParams = _h[1]; //data table data
    var _j = useState(false), openLeftPanel = _j[0], setOpenLeftPanel = _j[1];
    var _k = useState({}), selectedRow = _k[0], setSelectedRow = _k[1];
    var isMobileScreen = useMediaQuery("(max-width: 750px)");
    var _l = useState({}), selectedViewUser = _l[0], setSelectedViewUser = _l[1]; //when onclick the "eye" btn on list
    var _m = useState({ acl: acl }), accessDialogData = _m[0], setAccessDialogData = _m[1];
    var _o = useState({}), origDialogData = _o[0], setOrigDialogData = _o[1]; //original dialogData
    // dialog for add/edit user
    var _p = useState(false), dialogOpened = _p[0], setDialogOpened = _p[1];
    var _q = useState({}), dialogData = _q[0], setDialogData = _q[1];
    var _r = useState(null), selectedOrgId = _r[0], setSelectedOrgId = _r[1]; //this is to find which org id chose
    // const [selectedUserGroupIds, setSelectedUserGroupIds] = useState([]); //this is to handle "userGroup" vals after onchange
    var translateUsersClassHelper = new TranslateUsersOrgClassHelper(translate);
    // data table header
    var _s = useState([
        {
            id: translate("pages.subject.fields.id"),
            customId: translate("pages.subject.fields.customId"),
            firstname: translate("pages.subject.fields.firstname"),
            lastname: translate("pages.subject.fields.lastname"),
            gender: translate("pages.subject.fields.gender"),
            educationLevel: translate("pages.subject.fields.educationLevel"),
            dateOfBirth: translate("pages.subject.fields.dateOfBirth"),
            isHeader: true,
            selected: false,
        },
    ]), dataGridHeader = _s[0], setDataGridHeader = _s[1];
    var delAction = function (record) {
        var params = {
            data: {
                id: record.id,
                // customId: record.customId,  //[back] later switch to customId
                // firstname: record.firstname,
                // lastname: record.lastname,
                // gender: record.gender,
                // educationLevel: record.educationLevel,
                // dateOfBirth: record.dateOfBirth,
                // createby: 1,
                givenId: record.id, //[back] later switch to real id - id for db, not customId
            },
        };
        dataProvider.delete(resource, params).then(function () {
            refresh();
            notify(translate('pages.userList.notify.delete'));
        }).catch(function (error) {
            // Handle any errors that occurred
            console.error(error);
            notify(translate('error.userList.delFail'), {
                type: 'error',
            });
        });
        ;
    };
    useEffect(function () {
        var newParams = translateUsersClassHelper.translateAllParams(translate);
        setParams(__assign(__assign({}, params), { newParams: newParams }));
    }, [translate]);
    // get ACL for org (top bar)
    var getACL = function () {
        var _a;
        var cachedAuth = (_a = JSON.parse(localStorage.getItem("auth"))) !== null && _a !== void 0 ? _a : {};
        var settingsParams = {};
        if (cachedAuth) {
            settingsParams.id = cachedAuth.id;
            dataProvider
                .getOneWithoutDataJSON("users", settingsParams)
                .then(function (rtnData) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                localStorage.setItem("appBarOrg", (_d = (_c = (_b = (_a = rtnData === null || rtnData === void 0 ? void 0 : rtnData.profile) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b['current_organization']) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : "N/A");
                localStorage.setItem("userOrgId", (_h = (_g = (_f = (_e = rtnData === null || rtnData === void 0 ? void 0 : rtnData.profile) === null || _e === void 0 ? void 0 : _e.info) === null || _f === void 0 ? void 0 : _f['current_organization']) === null || _g === void 0 ? void 0 : _g[0]) !== null && _h !== void 0 ? _h : "N/A");
                setAcessControlList((_j = rtnData === null || rtnData === void 0 ? void 0 : rtnData.profile) === null || _j === void 0 ? void 0 : _j.ACL);
                refresh();
            })
                .catch(function (error) {
                // Handle any errors that occurred
                console.error(error);
                localStorage.setItem("appBarOrg", "N/A");
                localStorage.setItem("userOrgId", "N/A");
                notify(translate('error.ACL.getACLFailed'), {
                    type: 'error',
                });
            });
        }
    };
    var reloadRecord = function (values, dialogType) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPassword, updatedConfirmpw, userGroups, userParams, newEditUserGroups, updatedData;
        return __generator(this, function (_a) {
            setIsLoading(true);
            try {
                updatedPassword = !values.password || values.password === "" ? null : values.password;
                updatedConfirmpw = !values.confirmpw || values.confirmpw === "" ? null : values.confirmpw;
                if (updatedPassword != updatedConfirmpw) {
                    notify("Password not the same");
                    return [2 /*return*/];
                }
                userGroups = params.userGroups;
                userParams = {
                    data: {
                        // // "id": values.id,
                        // "username": values.username,
                        Last_name: values.Last_name,
                        First_name: values.First_name,
                        // "email": values.email,
                        language: values.language,
                        gender: values.gender,
                        // "organizations": [values.organizations],
                        // "userGroups": [values.userGroups],
                        // "password": values.password
                    },
                };
                if (values.password) {
                    userParams.data.password = values.password;
                }
                if (values.username) {
                    userParams.data.username = values.username;
                }
                if (values.email) {
                    userParams.data.email = values.email;
                }
                if (values.editOrganizations) {
                    userParams.data.organizationIds = [values.editOrganizations];
                }
                if (values.editUserGroups) {
                    newEditUserGroups = userGroups.filter(function (item) {
                        return values.editUserGroups.includes(item.id);
                    });
                    userParams.data.userGroupIds = newEditUserGroups.map(function (item) { return item.id; });
                }
                switch (dialogType) {
                    case "Create":
                        updatedData = __spreadArray([], data, true);
                        updatedData.push(values);
                        setData(updatedData);
                        dataProvider
                            .create(attributeResource, userParams)
                            .then(function (returnData) {
                            refresh();
                            notify("User added");
                            getACL();
                            closeDialog();
                            setIsLoading(false);
                        })
                            .catch(function (error) {
                            // Handle any errors that occurred
                            if (error == "HttpError2: email must be an email") {
                                notify(translate("error.login.email"), {
                                    type: 'error',
                                });
                            }
                            else if (error == "HttpError2: Invalid password type" ||
                                error.message.includes("Invalid password type")) {
                                notify(translate('error.login.invalidPWType'), {
                                    type: 'error',
                                });
                            }
                            else if (error == "HttpError2: Unauthorized") {
                                notify(translate("error.ACL.unauthorized"), {
                                    type: 'error',
                                });
                            }
                            else if (error == "HttpError2: This username or email is already in use." ||
                                error.message.includes("This username or email is already in use")) {
                                notify(translate("error.userList.createDupFail"), {
                                    type: 'error',
                                });
                            }
                            else {
                                notify(translate("error.userList.createFail"), {
                                    type: 'error',
                                });
                            }
                            refresh();
                            setIsLoading(false);
                        });
                        break;
                    case "Edit":
                        userParams.data.givenId = values.id;
                        dataProvider
                            .updateOne(attributeResource, userParams, values.id)
                            .then(function () {
                            refresh();
                            notify("User updated");
                            getACL();
                            closeDialog();
                            setIsLoading(false);
                        })
                            .catch(function (error) {
                            // Handle any errors that occurred
                            console.error(error);
                            // Handle any errors that occurred
                            if (error == "HttpError2: email must be an email") {
                                notify(translate("error.login.email"), {
                                    type: 'error',
                                });
                            }
                            else if (error == "HttpError2: Invalid password type" ||
                                error.message.includes("Invalid password type")) {
                                notify(translate('error.login.invalidPWType'), {
                                    type: 'error',
                                });
                            }
                            else if (error == "HttpError2: Unauthorized") {
                                notify(translate("error.ACL.unauthorized"), {
                                    type: 'error',
                                });
                            }
                            else if (error == "HttpError2: This username or email is already in use." ||
                                error.message.includes("This username or email is already in use")) {
                                notify(translate("error.userList.createDupFail"), {
                                    type: 'error',
                                });
                            }
                            else {
                                notify(translate("error.userList.createFail"), {
                                    type: 'error',
                                });
                            }
                            refresh();
                            setIsLoading(false);
                        });
                        break;
                }
                setDialogData(__assign({}, values));
            }
            catch (err) {
                console.log(err, "==err");
                refresh();
                // Handle any errors that occurred
                if (error == "HttpError2: email must be an email") {
                    notify(translate("error.login.email"), {
                        type: 'error',
                    });
                }
                else if (error == "HttpError2: Unauthorized") {
                    notify(translate("error.ACL.unauthorized"), {
                        type: 'error',
                    });
                }
                else {
                    notify(translate("error.userList.updateFail"), {
                        type: 'error',
                    });
                }
                refresh();
                setIsLoading(false);
                // dispatch(actionTypes.SNACKBAR_ERROR);
            }
            return [2 /*return*/];
        });
    }); };
    var setDialogDataAction = function (record) {
        var _a, _b, _c, _d, _e, _f, _g;
        setDialogData(__assign(__assign({ submit: null, dialogType: (record === null || record === void 0 ? void 0 : record.id) ? "Edit" : "Create", id: (_a = record === null || record === void 0 ? void 0 : record.id) !== null && _a !== void 0 ? _a : null, editOrganizations: (_c = (_b = record === null || record === void 0 ? void 0 : record.current_organization) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null, editUserGroups: (_e = (_d = record === null || record === void 0 ? void 0 : record.userGroups) === null || _d === void 0 ? void 0 : _d.map(function (group) { return group.id; })) !== null && _e !== void 0 ? _e : null }, record), { organization: { id: (_g = (_f = record === null || record === void 0 ? void 0 : record.current_organization) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : null } }));
    };
    var openEditDialog = function (record) {
        var _a, _b, _c;
        //open dialog
        setDialogDataAction(record);
        var orgId = (_b = (_a = record === null || record === void 0 ? void 0 : record.current_organization) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
        var newParams = __assign({}, params);
        //clear the stored from session storage
        newParams["userGroups"] = (_c = newParams["oriUserGroups"]) !== null && _c !== void 0 ? _c : [].filter(function (item) { return item.orgId === orgId; });
        setSelectedOrgId(orgId);
        setParams(newParams);
        // formik?.current?.resetForm();
        setDialogOpened(true);
    };
    // create
    var openCreateEditDialog = function () {
        // const orgId = record?.current_organization?.id ?? null;
        var cachedUserOrgId = localStorage.getItem("userOrgId");
        var obj = { dialogType: "Create", submit: null, organization: { id: cachedUserOrgId, }, editOrganizations: cachedUserOrgId, };
        // if (acessControlList?.user_admin?.create === false) {
        var newParams = __assign({}, params);
        // obj.organization = {};
        // obj.organization.id = cachedUserOrgId;
        // obj.editOrganizations = cachedUserOrgId;
        //clear the stored from session storage
        var updatedUserGroups = newParams["oriUserGroups"].filter(function (item) { return item.orgId === cachedUserOrgId; });
        newParams["userGroups"] = updatedUserGroups;
        console.log(updatedUserGroups, '==log obj', cachedUserOrgId, newParams);
        setParams(newParams);
        setSelectedOrgId(cachedUserOrgId);
        setDialogData(obj);
        // formik?.current?.resetForm();
        setDialogOpened(true);
    };
    var leftPanelOpenEditDialog = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        //open dialog
        // setDialogDataAction(dialogData)
        setDialogData(__assign(__assign({ submit: null, dialogType: "Edit", id: (_a = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.id) !== null && _a !== void 0 ? _a : null }, selectedRow), { editOrganizations: (_c = (_b = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.current_organization) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null, editUserGroups: (_e = (_d = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.userGroups) === null || _d === void 0 ? void 0 : _d.map(function (group) { return group.id; })) !== null && _e !== void 0 ? _e : null }));
        var orgId = (_g = (_f = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.current_organization) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : null;
        var newParams = __assign({}, params);
        //clear the stored from session storage
        newParams["userGroups"] = (_h = newParams["oriUserGroups"]) !== null && _h !== void 0 ? _h : [].filter(function (item) { return item.orgId === orgId; });
        setSelectedOrgId(orgId);
        setParams(newParams);
        // formik?.current?.resetForm();
        setDialogOpened(true);
    };
    var closeDialog = function () {
        setDialogOpened(false);
    };
    var closeLeftPanel = function () {
        setSelectedRow({});
        setOpenLeftPanel(false);
    };
    //update usergroups params according to org
    useEffect(function () {
        if (selectedOrgId) {
            var newParams = __assign({}, params);
            //clear the stored from session storage
            newParams["userGroups"] = newParams["oriUserGroups"].filter(function (item) { return item.orgId === selectedOrgId; });
            // setSelectedUserGroupIds([]);
            setParams(newParams);
        }
    }, [selectedOrgId]);
    useEffect(function () {
        refresh();
    }, [filters]);
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var newFilters, sessonStorageJSON, newParams, orgParams, orgData, userGroupData, usersData, err_1;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 4, , 5]);
                        newFilters = __assign({}, filters);
                        //if is redirected with userId, set in filter
                        if (location.state) {
                            newFilters.id = location.state.userId;
                        }
                        sessonStorageJSON = (_a = JSON.parse(sessionStorage.getItem("".concat(window.location.pathname, "_filter")))) !== null && _a !== void 0 ? _a : {};
                        if (sessonStorageJSON) {
                            setFilters(__assign(__assign({}, sessonStorageJSON), newFilters));
                        }
                        else {
                            setFilters(__assign({}, newFilters));
                        }
                        sessionStorage.setItem("".concat(window.location.pathname, "_filter"), JSON.stringify(__assign(__assign({}, sessonStorageJSON), newFilters)));
                        refresh();
                        searchFilterGroup();
                        newParams = __assign(__assign({}, params), translateUsersClassHelper.translateAllParams(translate));
                        orgParams = {
                            pagination: { page: 1, perPage: 200 },
                            sort: { field: "id", order: "ASC" },
                            filter: {},
                        };
                        return [4 /*yield*/, dataProvider.getListNoFilter("organizations", orgParams)];
                    case 1:
                        orgData = _d.sent();
                        orgData = (_b = orgData === null || orgData === void 0 ? void 0 : orgData.data) === null || _b === void 0 ? void 0 : _b.map(function (item) { return ({
                            id: item.id,
                            name: item.orgName,
                            value: item.id,
                        }); });
                        return [4 /*yield*/, dataProvider.getListNoFilter("userGroup", orgParams)];
                    case 2:
                        userGroupData = _d.sent();
                        userGroupData = (_c = userGroupData === null || userGroupData === void 0 ? void 0 : userGroupData.data) === null || _c === void 0 ? void 0 : _c.map(function (item) { return ({
                            id: item.id,
                            name: item.name,
                            value: item.id,
                            orgId: item.orgId,
                        }); });
                        newParams["organizations"] = orgData;
                        newParams["userGroups"] = [];
                        newParams["oriUserGroups"] = userGroupData;
                        setParams(newParams);
                        return [4 /*yield*/, dataProvider.getListNoFilter("users", orgParams)];
                    case 3:
                        usersData = _d.sent();
                        getACL();
                        setIsLoading(false);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _d.sent();
                        console.log(err_1, "==err");
                        setIsLoading(false);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var getCurrentViewingUser = function (userId) {
        var settingsParams = { id: userId };
        dataProvider
            .getOneWithoutDataJSON("users", settingsParams)
            .then(function (rtnData) {
            var _a, _b;
            // console.log(userId, { ...ACLData,...rtnData.profile.access }, rtnData.profile.access, '==hff')
            var rtnACL = __assign({}, (_a = rtnData === null || rtnData === void 0 ? void 0 : rtnData.profile) === null || _a === void 0 ? void 0 : _a.ACL);
            console.log("==================ff", rtnACL);
            setSelectedViewUser(__assign(__assign({}, accessDialogData), rtnACL));
            setAccessDialogData(__assign(__assign({}, accessDialogData), (_b = rtnData === null || rtnData === void 0 ? void 0 : rtnData.profile) === null || _b === void 0 ? void 0 : _b.ACL));
            setOpenLeftPanel(true);
        })
            .catch(function (error) {
            // Handle any errors that occurred
            setSelectedViewUser(__assign({}, ACLData.access)); //[back] [0815] remove this
            setAccessDialogData(__assign({}, accessDialogData));
            console.error(error);
        });
    };
    var searchFilterGroup = function () {
        var _a;
        setIsLoading(true);
        var sessonStorageJSON = (_a = JSON.parse(sessionStorage.getItem("".concat(window.location.pathname, "_filter")))) !== null && _a !== void 0 ? _a : {};
        // update the filter labels
        // let updatedFilters = JSON.parse(JSON.stringify(filters));
        // if (updatedFilters?.educationLevel) {
        //     updatedFilters.educationLevel = EducationLevelMuiChoices[filters.educationLevel].label
        // }
        // if (updatedFilters?.gender) {
        //     updatedFilters.gender = GenderMuiChoices[filters.gender].label
        // }
        var params = {
            pagination: { page: 1, perPage: 25 },
            sort: { field: "id", order: "ASC" },
            // filter: updatedFilters //[back][0715] resume this
            filter: __assign(__assign({}, filters), sessonStorageJSON),
        };
        dataProvider
            .getList(resource, params)
            .then(function (data) {
            refresh();
            notify("Users fetched");
            setIsLoading(false);
        })
            .catch(function (error) {
            // Handle any errors that occurred
            console.error(error);
            setIsLoading(false);
        });
    };
    return (_jsxs(Grid, { container: true, padding: BODY_GRID_PADDING, columnGap: NORMAL_GRID_SPACE, rowGap: 2, direction: { xs: "row", lg: "column" }, children: [openLeftPanel && (_jsx(Grid, { container: true, xs: 12, lg: 3, sx: {
                    // position: 'sticky',
                    top: 20,
                    height: 'fit-content'
                }, children: _jsx(SelectedRowLeftColumn, { myOrg: localStorage.getItem('appBarOrg') || '', acessControlList: acessControlList, translate: translate, selectedRow: selectedRow, setSelectedRow: setSelectedRow, openEditDialog: leftPanelOpenEditDialog, setOpenLeftPanel: setOpenLeftPanel, closeLeftPanel: closeLeftPanel, selectedViewUser: selectedViewUser, accessDialogData: accessDialogData, selectedOrgId: selectedOrgId, setSelectedOrgId: setSelectedOrgId, params: params }) })), _jsxs(Grid, { container: true, xs: 12, lg: openLeftPanel ? 9 : 12, alignContent: "start", justifyItems: "baseline", direction: "row", rowGap: 1, children: [_jsx(Grid, { xs: 12, children: _jsx(general.breadcrumb, { trail: [
                                translate("breadcrumb.userManagement"),
                                "".concat(translate("pages.userList.name")),
                            ] }) }), _jsxs(Grid, { xs: 12, display: "flex", alignItems: "center", justifyContent: "start", direction: "row", columnGap: NORMAL_GRID_SPACE, children: [_jsx(Grid, { children: _jsx(Typography, { className: "normal-text large-bold", children: translate("pages.userList.listName") }) }), (((_a = acessControlList === null || acessControlList === void 0 ? void 0 : acessControlList.user_admin) === null || _a === void 0 ? void 0 : _a.create) || ((_b = acessControlList === null || acessControlList === void 0 ? void 0 : acessControlList.user_normal) === null || _b === void 0 ? void 0 : _b.create)) && (_jsx(Grid, { children: _jsx(Button, { variant: "contained", startIcon: _jsx(AddCircleOutlineIcon, {}), onClick: openCreateEditDialog, children: translate("pages.userList.addNew") }) }))] }), _jsx(Grid, { xs: 12, children: _jsx(Divider, {}) }), _jsx(FilterList, { translate: translate, search: searchFilterGroup, isLoading: isLoading, params: params, filters: filters, setFilters: setFilters }), _jsx(TableDatagrid, { isMobileScreen: isMobileScreen, props: resource, data: data, myOrg: localStorage.getItem('appBarOrg') || '', setData: setData, setOrigDialogData: setOrigDialogData, translate: translate, setOpenLeftPanel: setOpenLeftPanel, getCurrentViewingUser: getCurrentViewingUser, acessControlList: acessControlList, selectedRow: selectedRow, setSelectedRow: setSelectedRow, openEditDialog: openEditDialog, filters: filters, setFilters: setFilters, isLoading: isLoading, setIsLoading: setIsLoading, delAction: delAction })] }), dialogOpened && (_jsx(EditDialog, { disableOrg: ((_c = acessControlList === null || acessControlList === void 0 ? void 0 : acessControlList.user_admin) === null || _c === void 0 ? void 0 : _c.create) === false && dialogData.dialogType === "Create", opened: dialogOpened, data: dialogData, isMobileScreen: isMobileScreen, closeDialog: closeDialog, reloadRecord: reloadRecord, translate: translate, params: params, selectedOrgId: selectedOrgId, setSelectedOrgId: setSelectedOrgId }))] }));
};
export default UserList;
